import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GroupService } from 'src/app/services/groupservice.service';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import 'moment/locale/es';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-madegroupform',
  templateUrl: './create-group.component.html',
  styleUrls: ['./create-group.component.scss'],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-MXN' }],
})
export class MadegroupformComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  public dummyFacilitators: any = this.data.facilitatiorList;
  public hideRequiredControl = new FormControl(true);
  public minDate: Date;
  public isCreating: boolean = true;
  public groupForm: FormGroup = this.fb.group({
    hideRequired: this.hideRequiredControl,
    groupName: ['', [Validators.required]],
    facilitatorName: ['', [Validators.required]],
    startDate: ['', [Validators.required]],
    endDate: ['', [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MadegroupformComponent>,
    private groupService: GroupService,
    @Inject(MAT_DIALOG_DATA)
    public data: { facilitatiorList: any; idOrganiztion: string },
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
    private _snackBar: MatSnackBar,
    private trasnlateService: TranslateService
  ) {
    this.minDate = new Date();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this._locale = 'es';
    this._adapter.setLocale(this._locale);
  }

  private createGroup(id: string, id2: string, body: any): void {
    this.subs.sink = this.groupService.madeGtoup(id, id2, body).subscribe({
      next: () => {
        this.closeModal(true);
        this.groupService.refreshGroupList(true);
        this._snackBar.open('Grupo creado con éxito', 'cerrar', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });
      },
      error: () => {
        this.closeModal(false);
        this.isCreating = true;
        this.groupService.refreshGroupList(true);
        this._snackBar.open('Ups! error al crear el grupo', 'cerrar', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'my-snackbar-error',
        });
      },
    });
  }

  public sendData(form: FormGroup): void {
    if (form.invalid) {
      this.markFormError(form);
    } else {
      const body = {
        group_name: this.groupForm.value.groupName,
        start_date: this.dateFormatPipe(this.groupForm.value.startDate),
        ending_date: this.dateFormatPipe(this.groupForm.value.endDate),
      };
      const idFacilitator = this.groupForm.value.facilitatorName;
      const idAlliedParameter = this.data.idOrganiztion;
      this.isCreating = false;
      this.createGroup(idFacilitator, idAlliedParameter, body);
    }
  }

  private markFormError(form: FormGroup): void {
    return Object.values(form.controls).forEach((control) => {
      control.markAllAsTouched();
    });
  }

  public dateFormatPipe(dateData: any): string {
    return moment(dateData).format('YYYY-MM-DD');
  }

  public closeModal(isCreated: boolean): void {
    this.dialogRef.close(isCreated);
  }
}
